/**
 * @generated SignedSource<<fcba319cccaf40c004b7a2327b9a77be>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type rewardsStatusHelper_rewards$data = {
  readonly currentProgram: {
    readonly programInfo: {
      readonly code: string | null;
      readonly shortCopy: string | null;
    } | null;
  } | null;
  readonly nextProgram: {
    readonly programInfo: {
      readonly code: string | null;
      readonly shortCopy: string | null;
    } | null;
  } | null;
  readonly pointsNeededToLevelUp: string | null;
  readonly pointsToMaintainStatus: number | null;
  readonly " $fragmentType": "rewardsStatusHelper_rewards";
};
export type rewardsStatusHelper_rewards$key = {
  readonly " $data"?: rewardsStatusHelper_rewards$data;
  readonly " $fragmentSpreads": FragmentRefs<"rewardsStatusHelper_rewards">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "rewardsStatusHelper_rewards"
};

(node as any).hash = "9cde014970924bd1212d1dbad72b7984";

export default node;
